import { Component } from '@angular/core';
import { SocialIntakeFormState } from '../../models/enums/social-intake-form-state.enum';

@Component({
  selector: 'social-intake-host',
  templateUrl: './social-intake-host.component.html',
  styleUrls: ['./social-intake-host.component.scss']
})
export class SocialIntakeHostComponent {
  currentFormState!: SocialIntakeFormState;
  socialIntakeFormState = SocialIntakeFormState;
}
